import { E2EKeyApi } from '@/shared/api/methods/E2EKeyApi'
import { Cookies } from '@/shared/helpers/Cookies'
import { getPublicKeyBase64 } from './keyStore'
import { isE2EESupported } from 'livekit-client'

/** Возможность устройства принимать секретные звонки (E2E-CALLS.md, §5). */
export const CAPABILITY_SECRET_CALLS = 'secret_calls'

/**
 * Секретные звонки умеет только браузер с шифрованием кадров (insertable
 * streams или RTCRtpScriptTransform). Без него принять такой звонок нельзя —
 * значит, и сообщать серверу о поддержке нельзя.
 */
export function deviceSupportsSecretCalls(): boolean {
  try {
    return isE2EESupported()
  } catch {
    return false
  }
}

let uploaded = false

/**
 * Ensure this device's E2E public key exists and is registered on the server.
 * Safe to call repeatedly (idempotent upsert); only actually runs once per load
 * and only when the user is authenticated. Never throws — E2E is best-effort and
 * must not block app startup.
 */
export async function ensureE2EIdentityUploaded(force = false): Promise<void> {
  if (uploaded && !force) return
  const userId = Cookies.get('userId')
  if (!userId) return

  try {
    const publicKey = await getPublicKeyBase64()
    await E2EKeyApi.putMyKey(publicKey, deviceSupportsSecretCalls() ? [CAPABILITY_SECRET_CALLS] : [])
    uploaded = true
  } catch (e) {
    // Non-fatal: secret chats will retry key upload on next launch.
    console.warn('[e2e] public key upload failed', e)
  }
}
